/**
 * The loop mode and name Godot's scene importer gives an imported glTF clip after the glTF importer
 * (`gltfImportNames.ts`): the name suffix rule, then the sidecar's `_subresources` entry.
 */
import { AnimationLoopMode } from '../scene/animation.js';
/** The suffixes `_pre_fix_node` tests in this order (`resource_importer_scene.cpp:746-756`). */
const LOOP_SUFFIXES = ['loop_mode', 'loop', 'cycle'];
/** How the scene importer imports `clip`: the suffix rule, then the sidecar entry under the name that remains. */
export function importedClip(clip, options) {
    let loopMode = clip.loops ? AnimationLoopMode.LINEAR : AnimationLoopMode.NONE;
    let name = clip.name;
    if (options.useNameSuffixes) {
        for (const suffix of LOOP_SUFFIXES) {
            const stripped = withoutMarker(name, suffix);
            if (stripped === null)
                continue;
            loopMode = AnimationLoopMode.LINEAR;
            name = stripped;
        }
    }
    return { name, loopMode: options.sidecarLoopModes.get(name) ?? loopMode };
}
/** The name without the trailing digits, control characters, spaces and `_` that Blender appends. */
function trimmedName(name) {
    let end = name.length;
    while (end > 0 && isTrailingFiller(name.charCodeAt(end - 1)))
        end--;
    return name.slice(0, end);
}
function isTrailingFiller(code) {
    const isDigit = code >= 0x30 && code <= 0x39;
    return isDigit || code <= 32 || code === 0x5f;
}
/**
 * `name` without the `marker` suffix, or null when it has none: `_teststr` and `_fixstr`
 * (`resource_importer_scene.cpp:403-445`). The trailing filler is tested without and kept after.
 */
function withoutMarker(name, marker) {
    const what = trimmedName(name);
    const filler = name.slice(what.length);
    const lower = what.toLowerCase();
    // Detected case-insensitively but removed case-sensitively: `_fixstr` calls `String::replace`.
    if (lower.includes(`$${marker}`))
        return what.replaceAll(`$${marker}`, '') + filler;
    if (lower.endsWith(`-${marker}`) || lower.endsWith(`_${marker}`)) {
        return what.slice(0, what.length - (marker.length + 1)) + filler;
    }
    return null;
}
//# sourceMappingURL=animationImport.js.map